module.exports = __webpack_public_path__ + "static/media/LogoDE.971e1f24.svg";